/**
 * v6 fix: `NavLink` was imported from the broken v5-internal path
 * `react-router-dom/cjs/react-router-dom` — same issue as AdminPanel.js,
 * and actually used here too (twice), so fixed by pointing at the real
 * package export rather than deleting.
 *
 * Both target routes (/admin/points/manage, /admin/points/transactions)
 * are present in App.js, so no dangling-link issue here.
 */
import { AppWrapper } from 'components'
import AuthProtected from 'containers/AuthProtected/AuthProtected'
import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import CSSModule from 'react-css-modules'
import { NavLink } from 'react-router-dom';
import messages from './messages';
import styles from './PointsManager.module.scss';

const PointsManager = ({ intl }) => {
    return (
        <AppWrapper
            showHeader
            showSideNav
            showHeadingRow
            headingText={intl.formatMessage(messages.pageHeadingText)}
        >
            <AuthProtected />

            <div className="container ml-4">
                <div className={`${styles.inner} row`}>
                    <NavLink to={'/admin/points/manage'} className={`${styles.box}`}>
                        <FormattedMessage {...messages.managePointsColumnText} />
                    </NavLink>
                    <NavLink to={'/admin/points/transactions'} className={`${styles.box}`}>
                        <FormattedMessage {...messages.pointsTransactionsColumnText} />
                    </NavLink>
                </div>
            </div>


        </AppWrapper>
    )
}

export default injectIntl(CSSModule(PointsManager, styles))